import axios from '@/utils/axios'
// 
const getExchangeRate = (query, config) => axios.get('/api/v1/pc/exchangeRate', query, config)

// 
const getClassifyList = (query, config) => axios.get('/api/v1/pc/home/classify', query, config)

// 
const getBrandList = (query = { type: '', classId: '' }, config) => axios.get('/api/v1/pc/class/brand', query, config)


const getPostType = (query, config) => axios.get('', query, config)


const getSendType = (query, config) => axios.get('', query, config)


const popularityBrand = (query, config) => axios.get('/api/v1/pc/popularity/brand', query, config)

const uploadImg = (data = {}, config = {

}) => axios.post('/api/v1/upload/oss/image')

export default {
    getExchangeRate,
    getClassifyList,
    getBrandList,
    getPostType,
    getSendType,
    popularityBrand,
    uploadImg
}



// WEBPACK FOOTER //
// ./src/api/modules/common.js